import { atom, useAtomValue } from 'jotai';
import { selectAtom } from 'jotai/utils';
import Game from "../classes/Game";
import { damselSkeletonAtom, toolSkeletonAtom } from '../hooks/spine';

export const moneyAtom = atom(0)

export const gameAtom = atom((get) => {
  const damselSkeleton = get(damselSkeletonAtom)
  const toolSkeleton = get(toolSkeletonAtom)
  return new Game({ damsel: damselSkeleton, tools: toolSkeleton })
})

export const balanceAtom = selectAtom(gameAtom, g => g.money)
export const levelIndexAtom = selectAtom(gameAtom, g => g.levelIndex)


export const useGame = () => {
  return useAtomValue(gameAtom)
}

export const devMenuOpenAtom = atom(false)

